import axios from "axios";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import history from "../../../modules/history";

const initialState = {
  consentSurvey: null,
};

const SET_CONSENT_SURVEY = "SET_CONSENT_SURVEY";

const getConsentSurvey = (state) => state?.consentSurvey;

export const consentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONSENT_SURVEY:
      const { consentSurvey } = action;
      return {
        ...state,
        consentSurvey: consentSurvey,
      };
    default:
      return state;
  }
};

const fetchConsentSurvey = (surveyId) => (dispatch) => {
  return axios
    .get(`/api/survey/definition/${surveyId}`)
    .then(({ data }) => {
      return dispatch({ type: SET_CONSENT_SURVEY, consentSurvey: data });
    })
    .catch((e) =>
      sendNotification("Error trying to fetch user lifecycle.", ToastType.ERROR)
    );
};

const submitSignedSurvey = (data) => (dispatch) => {
  return axios
    .post("/api/esignature", data)
    .then((r) => {
      setTimeout(() => {
        history.push("/study");
      }, 3000);
    })
    .catch((e) => {
      return Promise.reject(e?.response?.data?.error[0]);
    });
};

export const mapDispatchToProps = { fetchConsentSurvey, submitSignedSurvey };
export const mapStateToProps = (state) => {
  return {
    consentSurvey: getConsentSurvey(state),
  };
};
